"use strict";require("./_set-collection-of")("WeakSet");